<template>
  <div>
    <CurationRenderer
      class="jps-page"
      :curation="curation"
      :show-edit="showEdit"
      :page="page"
      @edit="edit()"
    />
  </div>
</template>

<script lang="ts" setup>
definePageMeta({
  qsearch: true,
  disableDefaultMargin: true,
})

const { getPageAndCache } = usePage()
const { page, meta } = await getPageAndCache()
useHead(meta)

const { langPath } = useI18n()
const router = useRouter()
const dataStore = useDataStore()
const { isSysad }  = useUserStore()

const curation = computed(() => {
  if (page && !page.error) {
    return dataStore.curation(getPageCurationId(page.id))
  }
  return null
})

const showEdit = computed(() => {
  return isSysad
})

const edit = () => {
  router.push(langPath(`/management/page/${page.id}`))
}
</script>

<style lang="scss" scoped></style>
